import { util } from 'riot';
import { getQueryParams, removeTokenFromURL } from './services/queryParams';
import { generateReport, initializeGenerator } from './generator';
import { handleError } from './errorHandler';
import { coreActions } from '@ambita/ambita-components-core';
import * as landRegistryApi from './api/LandRegistry';
import { mount } from './api/Tags';
import { dom } from '@fortawesome/fontawesome-svg-core';

dom.watch();

import './views/landRegistry/landRegistry.tag';
import './views/landRegistry/landRegistryRight.tag';
import './views/landRegistry/landRegistryCadastreSelector.tag';
import './views/landRegistry/landRegistryRightSelector.tag';
import './views/login/login.tag';
import './views/cadastreReport/cadastreReportSelector.tag';
import './views/cadastreReport/cadastreReport.tag';

// silently swallow riot template errors
util.tmpl.errorHandler = () => null;

const query = getQueryParams();

removeTokenFromURL();

function hasQueries() {
  return Object.keys(query).length > 0;
}

if (hasQueries()) {
  initializeGenerator(query)
    .then(() => generateReport(query))
    .catch((error) => {
      handleError(error);
    });
}

export const mountTags = function () {
  const autoMountedTags = Array.prototype.slice.apply(document.querySelectorAll('[infoland-automount]'));

  autoMountedTags.forEach((tag) => {
    mount(tag.tagName.toLowerCase());
  });
};

export const changeSettings = coreActions.changeSettings;

// tslint:disable-next-line variable-name
export const LandRegistry = landRegistryApi;

// versions are provided by webpack define plugin
declare const REPORT_VERSION: string;
declare const CORE_VERSION: string;
declare const MAP_VERSION: string;
declare const BACKEND_ENV: string;

window['VERSION'] = {
  report: REPORT_VERSION,
  core: CORE_VERSION,
  map: MAP_VERSION
};

window['AMBITA_CONFIG'] = {
  environment: BACKEND_ENV,
  organizationDataOverrides: {
    964963193: {
      name: 'Hurum kommune v/ Hurum Eiendomsselskap KF',
      address: {
        title: 'Øvre Skoledalen 1',
        postcode: '3482',
        city: 'Tofte'
      }
    }
  }
};
